import _ from 'lodash';
import { FETCH_VINCHECK_REQUEST, FETCH_VINCHECK_SUCCESS, FETCH_VINCHECK_FAILURE } from './constants';
import ApiService from '../../../services/api/ApiService';
import { versionsAdapter } from '../../../Utils/adapters/vincheck/versionAdapter';
import { vincheckAdapter } from '../../../Utils/adapters/vincheck/vincheckAdapter';
import { alertsAdapter } from '../../../Utils/adapters/vincheck/alertsAdapter';
import { vehicleAdapter } from '../../../Utils/adapters/vincheck/vehicleAdapter';

const fetchVinCheckRequest = () => ({
  type: FETCH_VINCHECK_REQUEST,
});

const fetchVinCheckSuccess = (recordId, vincheck) => ({
  type: FETCH_VINCHECK_SUCCESS,
  payload: vincheck,
  id: recordId,
});

const fetchVinCheckFailure = (error) => ({
  type: FETCH_VINCHECK_FAILURE,
  payload: error,
});

const adaptResponse = (vincheckData) => {
  const vincheck = {};
  _.set(vincheck, 'vincheck', vincheckAdapter(vincheckData));
  _.set(vincheck, 'versions', versionsAdapter(vincheckData));
  _.set(vincheck, 'alerts', alertsAdapter(vincheckData));
  _.set(vincheck, 'vehicle', vehicleAdapter(vincheckData));
  return vincheck;
};

export const fetchVinCheck = (recordId) => (dispatch) => {
  dispatch(fetchVinCheckRequest());
  ApiService('getVincheck', { recordId })
    .then((response) => {
      dispatch(fetchVinCheckSuccess(recordId, adaptResponse(response.data)));
    })
    .catch((error) => {
      dispatch(fetchVinCheckFailure(error.message));
    });
};
